<template>
  <n-flex justify="center" align="center" vertical>
    <p class="login-desc">Please sign in with your local account.</p>
    <n-input
      v-model:value="username"
      placeholder="Enter username"
      style="width: 200px; margin-bottom: 10px"
      @keyup.enter="handleLogin"
    />
    <n-button class="login-button" type="primary" @click="handleLogin" :loading="loading">
      Sign In
    </n-button>
    <n-alert v-if="error" title="Login Failed" type="error" style="margin-top: 10px">
      {{ error }}
    </n-alert>
  </n-flex>
</template>

<script setup>
import { ref } from 'vue'
import { NFlex, NButton, NInput, NAlert } from 'naive-ui'

const props = defineProps({
  login: {
    type: Function,
    required: true,
  },
})

const username = ref('dev.user@sequins.bio') // Default for convenience
const loading = ref(false)
const error = ref(null)

const handleLogin = async () => {
  if (!username.value) {
    error.value = 'Username is required.'
    return
  }
  loading.value = true
  error.value = null
  try {
    await props.login(username.value)
  } catch (e) {
    error.value = e.response?.data?.detail || e.message || 'An unknown error occurred.'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-desc {
  margin: 20px 0;
}
</style>
